import { Skeleton } from '@mui/material';

export default function SkeletonForm({ number, height = 60, ...other }) {
  return [...Array(number)].map((_, index) => <Skeleton key={index} variant="rectangular" height={height} sx={{ borderRadius: 1 }} />);
}
